// src/pages/SpaPage.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import AdminPage from '../pages/AdminPage';
import '../css/spaPage.css';
import {useTranslation} from "react-i18next";
import LoadingSpinner from "../components/LoadingSpinner";

function SpaPage() {
    const { t } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSteamUser, setIsSteamUser] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            try {
                const decodedToken = jwtDecode(accessToken);
                const userRoles = decodedToken.roles || [];
                const currentTime = Date.now() / 1000;

                if (decodedToken.exp < currentTime) {
                    localStorage.removeItem('access_token');
                    setIsAuthenticated(false);
                    setIsAdmin(false);
                    setIsSteamUser(false);
                    navigate('/');
                    setIsLoading(false);
                    return;
                }

                if (!decodedToken.username || !decodedToken.roles) {
                    localStorage.removeItem('access_token');
                    setIsAuthenticated(false);
                    setIsAdmin(false);
                    setIsSteamUser(false);
                    navigate('/');
                    setIsLoading(false);
                    return;
                }

                if (!Array.isArray(decodedToken.roles)) {
                    localStorage.removeItem('access_token');
                    setIsAuthenticated(false);
                    setIsAdmin(false);
                    setIsSteamUser(false);
                    navigate('/');
                    setIsLoading(false);
                    return;
                }

                if (decodedToken.roles.length === 0) {
                    localStorage.removeItem('access_token');
                    setIsAuthenticated(false);
                    setIsAdmin(false);
                    setIsSteamUser(false);
                    navigate('/');
                    setIsLoading(false);
                    return;
                }

                setIsAuthenticated(true);
                if (userRoles.includes('ROLE_ADMIN')) {
                    setIsAdmin(true);
                } else {
                    setIsAdmin(false);
                    navigate('/');
                }

                if (decodedToken.steamId) {
                    setIsSteamUser(true);
                } else {
                    setIsSteamUser(false);
                }

                setIsLoading(false);
            } catch (error) {
                setIsAuthenticated(false);
                setIsAdmin(false);
                setIsSteamUser(false);
                localStorage.removeItem('access_token');
                navigate('/');
                setIsLoading(false);
            }
        } else {
            setIsAuthenticated(false);
            setIsAdmin(false);
            setIsSteamUser(false);
            setIsLoading(false);
        }
    }, [navigate]);

    const handleLogin = () => {
        window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/steam`;
        const redirectPath = window.location.pathname;
        localStorage.setItem('redirectPath', redirectPath);
    };

    if (isLoading) {
        return <LoadingSpinner/>;
    }

    if (!isAuthenticated) {
        return (
            <div className="auth-container">
                <p>{t('messages.notLoggedIn')}</p>
                <button onClick={handleLogin} className="steam-login-button">
                    {t('messages.loginViaSteam')}
                </button>
            </div>
        );
    }

    if (!isSteamUser) {
        return (
            <div className="auth-container">
                <p>{t('messages.loginRequired')}</p>
                <button onClick={handleLogin} className="steam-login-button">
                    {t('messages.loginViaSteam')}
                </button>
            </div>
        );
    }

    if (isAdmin) {
        return (
            <div className="auth-container">
                <AdminPage />
            </div>
        );
    }

    return null;
}

export default SpaPage;
